import { Col, Row } from "react-bootstrap"
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from 'react-bootstrap-table2-editor';
import paginationFactory from 'react-bootstrap-table2-paginator';

function TableWithComponents({columns, items}){

    return (
        <Row>
            <Col>
            <BootstrapTable 
                    keyField='id' 
                    data={ items } 
                    columns={ columns } 
                    bordered={false}
                    classes="border-top-0 simple-table"
                    wrapperClasses="table-responsive-md"
                    noDataIndication="No hay información disponible"
                    cellEdit={
                        cellEditFactory({ 
                            mode: "click",
                        })
                    }
                    pagination={ paginationFactory() }
                />
            </Col>
        </Row>
    )

}

export default TableWithComponents